export const CONDITIONS = [
    { conditionId: 'activos', name: 'Activos' },
    { conditionId: 'correosValidos', name: 'Correos Válidos' },
    { conditionId: 'numerosValidos', name: 'Números Válidos' },
]
